import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  const features = [
    {
      icon: '⭐',
      title: 'Expert Team',
      description: 'Highly skilled professionals with extensive industry experience'
    },
    {
      icon: '🚀',
      title: 'Innovation Driven',
      description: 'We leverage the latest technologies and methodologies'
    },
    {
      icon: '💎',
      title: 'Quality Assurance',
      description: 'Rigorous quality checks ensure exceptional results'
    },
    {
      icon: '⏱️',
      title: 'Timely Delivery',
      description: 'We respect deadlines and deliver projects on time'
    },
    {
      icon: '💰',
      title: 'Cost Effective',
      description: 'Competitive pricing without compromising quality'
    },
    {
      icon: '🤝',
      title: 'Client Focused',
      description: 'Your satisfaction is our top priority'
    }
  ];

  return (
    <section className="why-us" id="why-us">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Choose BuildNex</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            We stand out from the competition with our commitment to excellence
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
